export const Spinner = () => {
  return (
    <div className='h-screen translate-x-1/2 translate-y-1/2'>
      <div className='h-16 w-16  animate-spin rounded-full border-4 border-t-primary-yellow' />
    </div>
  );
};
